import { Backdrop, Box, Fade, Grid, MenuItem, Modal, TextField, Typography, Button, styled, CircularProgress } from "@mui/material"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { useEffect, useState } from "react"
import 'dayjs/locale/cs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Close } from "@mui/icons-material";
import emailjs from 'emailjs-com';

const Text = styled(Typography)(({ theme }) => ({
    fontWeight: 600
}));

function ReservationModal({ openVar, onClose }) {
    const [open, setOpen] = useState(false)
    const [selectedDateFrom, setSelectedDateFrom] = useState(null);
    const [selectedDateTo, setSelectedDateTo] = useState(null);
    const [showInputs, setShowInputs] = useState(true);
    const [loading, setLoading] = useState(false);
    const setCloseModal = () => {
        setOpen(false)
        onClose()
        setShowInputs(true)
    }

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        service: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const sendEmail = (e) => {
        e.preventDefault();
        setLoading(true)
        formData.dateFrom = selectedDateFrom ? selectedDateFrom.format('DD-MM-YYYY') : '';
        formData.dateTo = selectedDateTo ? selectedDateTo.format('DD-MM-YYYY') : '';

        emailjs.send('service_6tw7c0y', 'template_owwwnii', formData, 'eRH3W8yfrL5rv9GW_')
            .then((response) => {
                setShowInputs(false)
                setLoading(false)
            }, (error) => {
                console.error('Failed to send email.', error);
            });
    };

    useEffect(() => {
        setOpen(openVar)
    }, [openVar, onClose])


    return (
        <>
            <Modal
                open={open}
                onClose={setCloseModal}
                slots={{ backdrop: Backdrop }}
                aria-hidden={false}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
                sx={{
                    overflow: { xs: "scroll", md: "hidden" },
                    height: "100%"
                }}
            >

                <Fade in={open}>

                    <Box sx={{
                        position: "absolute",
                        top: { xs: "none", md: "50%" },
                        left: { xs: "none", md: "50%" },
                        transform: { xs: "none", md: "translate(-50%, -50%)" },
                        backgroundColor: "white",
                        p: 5,
                        zIndex: 999,
                        width: { xs: "100%", md: "35rem" },
                        borderRadius: 4,
                    }}>
                        <Button sx={{
                            position: "absolute",
                            top: 3,
                            right: 1,
                        }} onClick={setCloseModal}>
                            <Close></Close>
                        </Button>
                        <Text variant="h4" color="primary">
                            Kontaktuje nás
                        </Text>
                        <Text mb={4} variant="body1" color="secondary">
                            Vyplntě formulář a my vám odpovíme
                        </Text>
                        <Box component="form" onSubmit={sendEmail} autoComplete="off" sx={{ width: "100%" }}>
                            <Grid container spacing={2} justifyContent={"center"}>
                                <Grid item xs={12} md={6}>
                                    <Text variant="body1">Jméno</Text>
                                    <TextField
                                        fullWidth
                                        name="name"
                                        value={formData.name}
                                        placeholder="Jméno"
                                        required
                                        onChange={(e) => handleChange(e)}
                                    ></TextField>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Text variant="body1">Telefon</Text>
                                    <TextField
                                        fullWidth
                                        type="phone"
                                        name="phone"
                                        value={formData.phone}
                                        placeholder="Telefon"
                                        required
                                        onChange={(e) => handleChange(e)}
                                    ></TextField>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Text variant="body1">Email</Text>
                                    <TextField
                                        fullWidth
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        placeholder="Email"
                                        required
                                        onChange={(e) => handleChange(e)}
                                    ></TextField>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Text variant="body1">Typ služby</Text>
                                    <TextField
                                        fullWidth
                                        select
                                        name="service"
                                        value={formData.service}
                                        placeholder="Typ služby"
                                        required
                                        onChange={(e) => handleChange(e)}
                                    >
                                        <MenuItem value="Půjčení dodávky">Půjčení dodávky</MenuItem>
                                        <MenuItem value="Půjčení dodávky s řidičem">Půjčení dodávky s řidičem</MenuItem>
                                        <MenuItem value="Stěhování">Stěhování</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}><Text variant="body1">Datum možné objednávky</Text></Grid>
                                <Grid item xs={6}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="cs">
                                        <DatePicker
                                            value={selectedDateFrom}
                                            label="od"
                                            sx={{
                                                width: "100%"
                                            }}
                                            onChange={(newValue) => {
                                                setSelectedDateFrom(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </LocalizationProvider>

                                </Grid>
                                <Grid item xs={6}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="cs">
                                        <DatePicker
                                            sx={{
                                                width: "100%"
                                            }}
                                            value={selectedDateTo}
                                            label="do"
                                            onChange={(newValue) => {
                                                setSelectedDateTo(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12}>
                                    <Text variant="body1">Zpráva</Text>
                                    <TextField
                                        fullWidth
                                        multiline
                                        name="message"
                                        minRows={3}
                                        value={formData.message}
                                        placeholder="Zpráva pro nás"
                                        onChange={(e) => handleChange(e)}
                                    ></TextField>
                                </Grid>

                                <Grid item xs={12}>
                                    {!showInputs && (
                                        <Typography mt={1} variant="subtitle2" color="green">Úspěšně odesláno</Typography>
                                    )}
                                    <Button disabled={loading || !showInputs} startIcon={loading ? <CircularProgress size={20} /> : false} variant="contained" type="submit" color={"secondary"} fullWidth >
                                        {!showInputs ? (
                                            <>Odesláno</>
                                        ) : (
                                            <>Odeslat
                                            </>
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </>
    )

}

export default ReservationModal;